import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import '../../App.css';
import '../../css/bootstrap.scss';
import signup_banner from "../../images/fx-rates.png";
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import { useLocation, useNavigate } from "react-router-dom";
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import renderField from '../renderField';
import { ToastBox, notifyError, notifySuccess } from 'MyComponents/Toaster';
import SuccessOTPModal from '../Camera/SuccessOTPModal';
import Spinner from 'react-bootstrap/Spinner';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface FormData {
    password: string;
}

interface Props { };

const VerifyResetPassword: React.FC<Props & InjectedFormProps<{}, Props, FormData>> = (props: any) => {
    const { t } = useTranslation();
    const { handleSubmit, reset } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const resetCode = queryParams.get('resetCode');

    const [passwordValidationError, setPasswordValidationError] = useState(false);
    const [validations, setValidations] = useState({
        minLength: false,
        hasNumber: false,
        hasUppercase: false,
        hasSpecialCharacter: false,
        hasLowercase: false
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [passwordValidation, setPasswordValidation] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleShowModal1 = () => {
        setShowModal1(true);
    };

    const handleCloseModal1 = async () => {
        setShowModal1(false);
        navigate('/onboardingLoginAccount');
    };

    const validatePasswordField = (value: any) => {
        if (!value) {
            return t('common.password_required');
        }
        return undefined;
    };

    const resetPassword_baseURL = config.NODE_API_BASE_URL_V2 + '/wso2/resetPassword';

    const submitForm = async (formValues: FormData) => {
        setIsSubmitted(true);

        if (passwordValidationError) {
            setPasswordValidation(true);
            return;
        }

        if (!resetCode) {
            notifyError("Reset code is missing.");
            return;
        }

        setLoading(true);

        try {
            const Response = await axios.post(resetPassword_baseURL, {
                resetCode: resetCode,
                password: formValues.password
            });

            if (Response.data.status) {
                setIsSubmitted(false);
                handleShowModal1();
            } else {
                notifyError(Response.data.message || "Failed to reset password.");
            }
        } catch (error: any) {
            notifyError(error.response?.data?.message || "An error occurred while resetting password.");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = useCallback((e: any) => {
        const newPassword = e.target.value;
        setPasswordValidation(false);
        setValidations({
            minLength: newPassword.length >= 8,
            hasNumber: /\d/.test(newPassword),
            hasUppercase: /[A-Z]/.test(newPassword),
            hasSpecialCharacter: /[!@#$%^&*(),.?":{}|<>]/.test(newPassword),
            hasLowercase: /[a-z]/.test(newPassword),
        });
    }, []);

    useEffect(() => {
        const hasValidationError = Object.values(validations).some((valid) => !valid);
        setPasswordValidationError(hasValidationError);
    }, [validations]);

    return (
        <>
            <Header />

            <SuccessOTPModal
                show={showModal1}
                handleClose={handleCloseModal1}
                title={t('camera.reset_completed')}
            />

            <ToastBox />
            <Container fluid className='min-vh-custom'>
                <Row>
                    <Col md={1}></Col>
                    <Col md={5}>
                        <div className='mt-5 px-4'>
                            <br /><br /><br />
                            <p className='text-primary fw-medium fs-5 mt-5'>{t('login.create_new_password')}</p>
                            <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                                <label htmlFor="password" className="form-label">{t('common.password')}</label>
                                <div className='input-group password_field'>
                                    <Field
                                        type={showPassword ? 'text' : 'password'}
                                        component={renderField}
                                        className="form-control rounded-5 py-2 mt-2"
                                        placeholder={t('login.type_password')}
                                        id="password"
                                        name="password"
                                        validate={validatePasswordField}
                                        required
                                        onChange={handleChange}
                                    />

                                    {passwordValidation && (
                                        <p className='text-danger text-start small fw-bold mt-2'>
                                            {t('login.invalid_password')}
                                        </p>
                                    )}
                                    <span
                                        className="bg-transparent border-0 icon p-eye"
                                        onClick={handleTogglePassword}
                                    >
                                        <i className={showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                                    </span>
                                </div>
                                <div className='mt-3 col-md-11 bg-sky rounded-4'>
                                    <Form.Text className="text-muted">
                                        <div className='px-3 py-3 pb-3'>
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.minLength ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_min_length')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasNumber ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_number')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasUppercase ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_upper')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasLowercase ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_lower')}
                                            </span>
                                            <br />
                                            <span className="text-secondary">
                                                <i className={`fa-solid ${validations.hasSpecialCharacter ? 'fa-circle-check text-success' : 'fa-circle-xmark text-danger'}`}></i>
                                                &nbsp;&nbsp;&nbsp;&nbsp;{t('common.pass_has_special')}
                                            </span>
                                        </div>
                                    </Form.Text>
                                </div>

                                <div className='col-md-6 mt-4'>
                                    <Button variant="primary" type="submit" className="btn btn-primary rounded-5 mt-3" disabled={loading}>
                                        {loading && (
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='mx-2'
                                            />
                                        )}
                                        <span>{t('login.reset_title')}</span>
                                    </Button>{' '}
                                </div>
                            </Form>
                        </div>
                    </Col>
                    <Col md={6} className='text-center bg-sky'>
                        <br /><br /><br /><br /><br /><br />
                        <img src={signup_banner} className="img-fluid" style={{ maxWidth: 500, width: "100%" }} alt="banner" />
                        <br /><br /><br />
                        <h2>{t('common.all_in_one')}</h2>
                        <p className='text-secondary mb-3'>{t('common.all_in_one_desc')}</p>
                    </Col>
                </Row>
            </Container>
            <Footer full={false} />
        </>
    );
};

const VerifyResetPasswordForm = reduxForm<{}, Props, FormData>({
    form: 'verifyResetPassword',
    enableReinitialize: true,
})(VerifyResetPassword);

export default VerifyResetPasswordForm;
